export default __webpack_public_path__ + "static/media/jp.b2e3c6aa.svg";